<template>
  <div class="homepage-container container">
    <h1
      v-if="homePage.welcome_message"
      class="d-flex justify-content-center align-items-center"
    >
      {{ homePage.welcome_message }}
    </h1>
    <h1 v-else class="visually-hidden">Welcome to Highland Park Village</h1>

    <section>
      <FeaturedHomepageStores
        :featuredStores="featuredItems"
      ></FeaturedHomepageStores>
    </section>

    <section>
      <Ctas :featuredServices="featuredItems" :galleryData="galleries"></Ctas>
    </section>
  </div>

</template>

<script setup>
definePageMeta({
  layout: "default",
});
import { useMainStore } from "~/store";
import { storeToRefs } from "pinia";

const store = useMainStore();
const { processedStores, loadSeo, loadPageData, getMMData, baseURL } = storeToRefs(store);

// *** SEO *** //
let currentSEO = await useSeo("/");
useHead(currentSEO.value);

const homePage = store.homepageData;
const featuredItems = homePage.feature_items ? homePage.feature_items : [];
const galleries = store.galleryData ? store.galleryData : [];
</script>

<style lang="scss" scoped>
.homepage-container {
  width: 100%;
  margin: 54px auto;

  .visually-hidden {
    position: absolute !important;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  h1 {
    font-family: $font_didot_italic !important;
    letter-spacing: -2px;
    font-size: 4.5rem;
    text-align: center;
    margin-bottom: 50px;
    font-weight: normal;
    padding: 0 10%;

    @media only screen and (max-width: 992px) {
      font-size: 2.75rem;
    }

    @media only screen and (max-width: 560px) {
      font-size: 2em;
      margin-bottom: 30px;
    }

    @media only screen and (max-width: 468px) {
      font-size: 1.5em;
    }
  }
}
</style>